import React from 'react'

import { PageWrapper } from '@jelly/components'
import { AdvertisingDisclosure } from '../TopFiveQT/AdvertisingDisclosure'
import Header from './Header'
import Footer from './Footer'

export function TemplateWrapper({ children, meta }) {
	return (
		<PageWrapper meta={meta}>
			<AdvertisingDisclosure />
			<Header />
			{children}
			<Footer />
		</PageWrapper>
	)
}
